import React from 'react';
import Header from './header/Header';
import Messaging from './messaging/Messaging';
import { isMobileOnly } from 'react-device-detect';
import { observer } from 'mobx-react';

import { ArrowBack } from '@material-ui/icons'; 

import { RootStoreContext } from '../../../../context';
import { ANCHOR_LIST } from '../../../../constants/apiUrls/apiUrls';
import callApi from "../../../../utils/callApi"

import './ActiveConversation.css';

@observer
class ActiveConversation extends React.Component {

  static contextType = RootStoreContext;

  state = {
    currentAnchors: []
  }

  componentDidMount(){
    callApi(ANCHOR_LIST, 'get', {})
    .then(res => {
      this.setState({currentAnchors: res.data.currentAnchors})
    })
  }

  activateSidebar = () => {
    this.context.privateMessagingStore.resetConversationSession();
    this.context.privateMessagingStore.openMobileSidebar();
  }

  componentWillUnmount () {
    this.activateSidebar();
  }

  render () {
    let display = isMobileOnly && this.context.privateMessagingStore.displaySidebar ? false : true;
    return (
      <div
        id="private-chat-active-conversation"
        style={!display ? { display: 'none' } : null}>
        <button
          onClick={this.activateSidebar}
          className="back-to-sidebar">
          <ArrowBack fontSize="inherit" /> 
          Conversations
        </button>
        <Header currentAnchors={this.state.currentAnchors}/>
        <Messaging />
      </div>
    );
  }
}

export default ActiveConversation;